// 电影相关
import {getAllCity,getToken} from "@/api/cinema";
import { setCookies } from '@/utils';
import {Toast} from "vant";

export default {
	namespaced: true,
	state: {
		cityName: '',
		cityList: [],
		mobile:'',
		code:'',
		token: '',
		backUrl:'', // 回跳地址
		param:'', // 透传参数
	},
	getters: {},
	mutations: {
		setCityName(state, data) {
			state.cityName = data;
		},
		setCityList(state, data) {
			state.cityList = data
		},
		setToken(state, data) {
			state.token = data
		},
		setBackUrl(state, data) {
			state.backUrl = data
		},
		setParam (state, data) {
			state.param = data
		},

	},
	actions: {
		async getCityList({ commit }){
			await getAllCity().then(res=>{
				commit('setCityList', res.data)
			}).catch(e=>{
				console.log(e)
			})
		},
		async getToken({ commit }){
			let obj = window.SITE_CONFIG['theRequest'];
			let params = {
				code: obj.code??'',
				appid: obj.appid??'',
				sign: obj.sign,
				timestamp: obj.timestamp,
				mobile: obj.mobile,
				addRatio: obj.addRatio??'',
				// partnerId: obj.partnerId,
				cityName: obj.cityName??'',
				param: obj.param??''
			};
			await getToken(params).then(res=>{
				commit('setToken', res.data.access_token)
				setCookies('token', res.data.access_token, res.data.exp_time);
				if(res?.data?.auth_info?.pay_url){
					commit('setBackUrl', res.data.auth_info.pay_url)
					commit('setParam', params.param)
				}
			}).catch(e=>{
				Toast.fail(e.msg || '请求失败');
				console.log(e)
			})
		}

	}
}
